import { useEffect, useRef } from 'react';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import Graphic from '@arcgis/core/Graphic';
import { assertGeographic, geographicPoint } from '../constants';
export function usePointPlacement({ mapView, isPlacingPoint, onPointPlaced, placedPoint, pointLayerRef, }) {
    const clickHandlerRef = useRef(null);
    // Initialize point layer
    useEffect(() => {
        const view = mapView;
        if (!view || !view.map)
            return;
        if (!pointLayerRef.current) {
            pointLayerRef.current = new GraphicsLayer();
            view.map.add(pointLayerRef.current);
        }
    }, [mapView, pointLayerRef]);
    // Handle point placement click events
    useEffect(() => {
        const view = mapView;
        if (!view)
            return;
        // Remove existing click handler
        if (clickHandlerRef.current) {
            clickHandlerRef.current.remove();
            clickHandlerRef.current = null;
        }
        if (isPlacingPoint && onPointPlaced) {
            view.when(() => {
                clickHandlerRef.current = view.on("click", (event) => {
                    const point = assertGeographic(event.mapPoint);
                    onPointPlaced([point.longitude, point.latitude]);
                });
            });
        }
        return () => {
            if (clickHandlerRef.current) {
                clickHandlerRef.current.remove();
                clickHandlerRef.current = null;
            }
        };
    }, [isPlacingPoint, onPointPlaced, mapView]);
    // Display placed point
    useEffect(() => {
        const pointLayer = pointLayerRef.current;
        const view = mapView;
        if (!pointLayer)
            return;
        pointLayer.removeAll();
        if (placedPoint && placedPoint.length >= 2) {
            const point = geographicPoint(placedPoint[0], placedPoint[1]);
            const pointGraphic = new Graphic({
                geometry: point,
                symbol: {
                    type: "simple-marker",
                    color: [255, 0, 0],
                    size: 12,
                    outline: {
                        color: [255, 255, 255],
                        width: 2
                    }
                }
            });
            pointLayer.add(pointGraphic);
            // Zoom to point if map is ready
            if (view) {
                view.when(() => {
                    view.goTo({
                        center: [placedPoint[0], placedPoint[1]],
                        zoom: 15
                    }, {
                        duration: 500
                    });
                });
            }
        }
    }, [placedPoint, mapView, pointLayerRef]);
}
